// extracted by mini-css-extract-plugin
export default {"wrapText":"RefundButton_wrapText__Mfick"};